<template>
  <div class="icon-bubble">
    <img :src="src" :alt="alt" :class="{ 'scale-img': scaleImg }" />
  </div>
</template>

<script setup>
defineProps({
  src: {
    type: String,
    default: '',
  },
  scaleImg: {
    type: Boolean,
    default: true,
  },
  alt: {
    type: String,
    default: '',
  },
})
</script>

<style scoped lang="postcss">
.icon-bubble {
  @apply rounded-full flex justify-center items-center;
  /* box-shadow: 0px 1.75px 15px rgba(0, 0, 0, 0.18); */
  box-shadow: 0px 0px 5px 0px #bdb8d540;
}

@media screen and (max-width: 768px) {
  .scale-img {
    transform: scale(0.6);
  }
}
</style>
